import BpmnJS from "bpmn-js";

/**
 * Converts a BPMN file to an image.
 * @param bpmnJS - The BpmnJS instance to use for conversion.
 * @param type - The desired output type: 'png', 'svg', or 'jpeg'.
 * @returns A Promise resolving to the image data blob
 */
export async function bpmnToImage(
    bpmnJS: BpmnJS,
    type: "png" | "svg" | "jpeg"
): Promise<Blob | null> {
    try {
        const { svg } = await bpmnJS.saveSVG();
        if (type === "svg") {
            return new Blob([svg], { type: "image/svg+xml" });
        } else {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d")!;

            const img = new Image();
            return new Promise((resolve, reject) => {
                img.onload = () => {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    // Export as PNG or JPEG
                    canvas.toBlob(function (blob) {
                        resolve(blob);
                    }, `image/${type}`);
                };

                img.onerror = reject;
                img.src = `data:image/svg+xml;base64,${btoa(svg)}`;
            });
        }
    } catch (error) {
        console.error("Error converting BPMN to image:", error);
        throw new Error("Failed to convert BPMN to image.");
    }
}
